const translations = {
    continue: 'Continue'
};

export default translations;
